export enum TmaMode {
    None = 0,
    Classic = 1,
    Combined = 2,
    LessRequests = 3,
}
